module.exports = __webpack_public_path__ + "static/media/cams-ncp-copernicus.e18faab2.png";